<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="flowRequirementForm" :model="formData" class="full-width-input" :disable="readOnly"
             :rules="rules" style="width: 100%;"
             label-width="120px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">

        <el-col :span="12">
          <el-form-item label="需求主体名称" prop="Requirement.mainBody">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.Requirement.mainBody"
                      :clearable="true" placeholder="需求主体名称"
            />
            <span class="input-item input-label" v-else>{{formData.Requirement.mainBody}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="需求主体联系人" prop="Requirement.mainContact">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.Requirement.mainContact"
                      :clearable="true" placeholder="需求主体联系人"
            />
            <span class="input-item input-label" v-else>{{formData.Requirement.mainContact}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="需求主体手机" prop="Requirement.mainPhone">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.Requirement.mainPhone"
                      :clearable="true" placeholder="需求主体手机"
            />
            <span class="input-item input-label" v-else>{{formData.Requirement.mainPhone}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="座机" prop="Requirement.landline">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.Requirement.landline"
                      :clearable="true" placeholder="座机"
            />
            <span class="input-item input-label" v-else>{{formData.Requirement.landline}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电子邮箱" prop="Requirement.eMail">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.Requirement.eMail"
                      :clearable="true" placeholder="电子邮箱"
            />
            <span class="input-item input-label" v-else>{{formData.Requirement.eMail}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="行业" prop="Requirement.industryId">
            <el-cascader class="input-item" v-if="!readOnly" v-model="flowRequirementForm.industryId.value" :options="flowRequirementForm.industryId.impl.dropdownList" filterable
                         :clearable="true" :show-all-levels="false" placeholder="行业"
                         :props="{value: 'id', label: 'name', checkStrictly: true}"
                         @visible-change="flowRequirementForm.industryId.impl.onVisibleChange"
                         @change="onIndustryIdValueChange"
            />
            <span class="input-item input-label" v-else>{{(formData.Requirement.industryIdDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="需求类型" prop="Requirement.subjectType">
            <el-select class="input-item" v-if="!readOnly" v-model="formData.Requirement.subjectType" :clearable="true" filterable
                       placeholder="需求类型" :loading="flowRequirementForm.subjectType.impl.loading"
                       @visible-change="flowRequirementForm.subjectType.impl.onVisibleChange"
                       @change="onSubjectTypeValueChange">
              <el-option v-for="item in flowRequirementForm.subjectType.impl.dropdownList" :key="item.id"
                         :value="item.id" :label="item.name"
              />
            </el-select>
            <span class="input-item input-label" v-else>{{(formData.Requirement.subjectTypeDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="地区" prop="Requirement.areaId">
            <el-cascader class="input-item" v-if="!readOnly" v-model="flowRequirementForm.areaId.value" :options="flowRequirementForm.areaId.impl.dropdownList" filterable
                         :clearable="true" :show-all-levels="true" placeholder="地区"
                         :props="{value: 'id', label: 'name', checkStrictly: true}"
                         @visible-change="flowRequirementForm.areaId.impl.onVisibleChange"
                         @change="onAreaIdValueChange"
            />
            <span class="input-item input-label" v-else>{{(formData.Requirement.areaIdDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址" prop="Requirement.address">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.Requirement.address"
                      :clearable="true" placeholder="详细地址"
            />
            <span class="input-item input-label" v-else>{{formData.Requirement.address}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="需求主题" prop="Requirement.subjectName">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.Requirement.subjectName"
                      :clearable="true" placeholder="需求主题"
            />
            <span class="input-item input-label" v-else>{{formData.Requirement.subjectName}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关键词" prop="Requirement.keyWord">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.Requirement.keyWord"
                      :clearable="true" placeholder="关键词(100字以内)" maxlenth="100"
            />
            <span class="input-item input-label" v-else>{{formData.Requirement.keyWord}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="需求描述" prop="Requirement.requirementDesc">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.Requirement.requirementDesc"
                      type="textarea"
                      :autosize="{minRows: 1, maxRows: 4}"
                      :clearable="true" placeholder="需求描述(300字以内)" maxlenth="300"
            />
            <span class="input-item input-label" v-else>{{formData.Requirement.requirementDesc}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="有效期" prop="Requirement.validity">
            <el-select class="input-item" v-if="!readOnly" v-model="formData.Requirement.validity" :clearable="true" filterable
                       placeholder="有效期" :loading="flowRequirementForm.validity.impl.loading"
                       @visible-change="flowRequirementForm.validity.impl.onVisibleChange"
                       @change="onValidityValueChange">
              <el-option v-for="item in flowRequirementForm.validity.impl.dropdownList" :key="item.id"
                         :value="item.id" :label="item.name"
              />
            </el-select>
            <span class="input-item input-label" v-else>{{(formData.Requirement.validityDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否公开" prop="Requirement.isOpen">
            <el-select class="input-item" v-if="!readOnly" v-model="formData.Requirement.isOpen" :clearable="true" filterable
                       placeholder="是否公开" :loading="flowRequirementForm.isOpen.impl.loading"
                       @visible-change="flowRequirementForm.isOpen.impl.onVisibleChange"
                       @change="onIsOpenValueChange">
              <el-option v-for="item in flowRequirementForm.isOpen.impl.dropdownList" :key="item.id"
                         :value="item.id" :label="item.name"
              />
            </el-select>
            <span class="input-item input-label" v-else>{{(formData.Requirement.isOpenDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="(userInfo.isSpecial && userInfo.isSpecial==='2')||
        formData.Requirement.createType==='2'">
          <el-form-item label="是否帮助上传" prop="Requirement.isHelp">
            <el-select class="input-item" v-if="!readOnly" v-model="formData.Requirement.isHelp" :clearable="true" filterable
                       placeholder="是否帮助上传" :loading="flowRequirementForm.isHelp.impl.loading"
                       :disabled="!(userInfo.isSpecial && userInfo.isSpecial==='2')"
                       @visible-change="flowRequirementForm.isHelp.impl.onVisibleChange"
            >
              <el-option v-for="item in flowRequirementForm.isHelp.impl.dropdownList" :key="item.id"
                         :value="item.id" :label="item.name"
              />
            </el-select>
            <span class="input-item input-label" v-else>{{(formData.Requirement.isHelpDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="对接状态" prop="Requirement.isDocking">
            <el-select class="input-item" v-if="!readOnly" v-model="formData.Requirement.isDocking" :clearable="true"
                       filterable
                       placeholder="对接状态" :loading="flowRequirementForm.isDocking.impl.loading"
                       @visible-change="flowRequirementForm.isDocking.impl.onVisibleChange"
                       @change="onIsDockingValueChange">
              <el-option v-for="item in flowRequirementForm.isDocking.impl.dropdownList" :key="item.id"
                         :value="item.id" :label="item.name"
              />
            </el-select>
            <span class="input-item input-label" v-else>{{(formData.Requirement.isDockingDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="formData.Requirement.isDocking===1">
          <el-form-item label="对接详情" prop="Requirement.dockingDesc">
            <el-input type="textarea" :rows="2" class="input-item" v-if="!readOnly"
                      v-model="formData.Requirement.dockingDesc"
                      :clearable="true" placeholder="对接详情"
            />
            <span class="input-item input-label" v-else>{{formData.Requirement.dockingDesc}}</span>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="附件照片" prop="Requirement.attachedImages">
            <el-upload v-if="!readOnly"
                       class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                       :action="getUploadActionUrl('/admin/app/requirement/upload')"
                       :data="{fieldName: 'attachedImages', asImage: true}"
                       :on-success="onAttachedImagesUploadSuccess"
                       :on-remove="onAttachedImagesRemoveFile"
                       :before-upload="pictureFile"
                       :on-error="onUploadError"
                       :show-file-list="true"
                       :on-preview="handlePreview"
                       :limit="flowRequirementForm.attachedImages.impl.maxCount"
                       :on-exceed="onUploadLimit"
                       :file-list="flowRequirementForm.attachedImages.impl.fileList"
                       list-type="picture">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <template v-else>
              <el-image v-for="item in flowRequirementForm.attachedImages.impl.fileList" :key="item.url"
                        :preview-src-list="getPictureList(formData.Requirement.attachedImages, {id: formData.Requirement.id,
                        fieldName: 'attachedImages', asImage: true})"
                        class="table-cell-image" :src="item.url" />
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />

  </div>
</template>

<script>
import { mapActions } from 'vuex';
/* eslint-disable-next-line */
  import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
  import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
  import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
import flowMixins from '../../mixins/flowMixins.js';
/* eslint-disable-next-line */
  import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
  import { RequirementRelateController, RequirementController, DictionaryController } from '@/api';
import { FlowOperationController } from '@/api/flowController.js';

const processDefinitionKey = 'flowRequirementAudit';

export default {
  name: 'flowRequirementForm',
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')

  },
  props: {
    // 是否运行时任务
    isRuntimeTask: {
      type: [Boolean, String]
    },
    // 是否草稿
    isDraft: {
      type: [Boolean, String],
      default: false
    },
    // 是否只读
    readOnly: {
      type: Boolean,
      default: false
    },
    // 流程实例id
    processInstanceId: {
      type: String
    },
    // 抄送消息id
    messageId: {
      type: String
    },
    // 当前任务实例id
    taskId: {
      type: String
    },
    // 任务变量列表
    taskVariableList: {
      type: Array
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, flowMixins],
  data () {
    return {
      imgViewerVisible: false,
      imgList: [],
      formData: {
        Requirement: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          subjectName: undefined,
          subjectType: undefined,
          industryId: undefined,
          userName: undefined,
          keyWord: undefined,
          userPhone: undefined,
          requirementDesc: undefined,
          attachedImages: undefined,
          specialistIds: undefined,
          specialistNames: undefined,
          isDocking: undefined,
          dockingTime: undefined,
          mainBody: undefined,
          mainPhone: undefined,
          landline: undefined,
          eMail: undefined,
          areaId: undefined,
          address: undefined,
          validity: undefined,
          isOpen: undefined,
          isHelp: undefined,
          requirementRelateList: [],
          sysUser: {
            userId: undefined,
            loginName: undefined,
            password: undefined,
            deptId: undefined,
            showName: undefined,
            userType: undefined,
            headImageUrl: undefined,
            userStatus: undefined,
            deletedFlag: undefined,
            createUserId: undefined,
            updateUserId: undefined,
            createTime: undefined,
            updateTime: undefined
          },
          isDatasourceInit: false,
          createType: false
        }
      },
      // 保存草稿后返回的taskId
      draftTaskId: undefined,
      // 保存草稿后返回的流程实例ID
      draftProcessInstanceId: undefined,
      rules: {
        'Requirement.industryId': [
          {required: true, message: '请输入行业', trigger: 'blur'}
        ],
        'Requirement.subjectType': [
          {required: true, message: '请输入需求类型', trigger: 'blur'}
        ],
        'Requirement.subjectName': [
          {required: true, message: '请输入需求主题', trigger: 'blur'}
        ],
        'Requirement.keyWord': [
          {required: true, message: '请输入关键词', trigger: 'blur'}
        ],
        'Requirement.requirementDesc': [
          {required: true, message: '请输入需求描述', trigger: 'blur'}
        ],
        'Requirement.mainContact': [
          {required: true, message: '请输入需求主体联系人', trigger: 'blur'}
        ],
        'Requirement.mainPhone': [
          {required: true, message: '请输入需求主体手机', trigger: 'blur'}
        ],
        'Requirement.mainBody': [
          {required: true, message: '请输入需求主体名称', trigger: 'blur'}
        ],
        'Requirement.areaId': [
          {required: true, message: '请选择地区', trigger: 'change'}
        ],
        'Requirement.isHelp': [
          {required: true, message: '请选择是否帮助上传', trigger: 'change'}
        ]
      },
      flowRequirementForm: {
        formFilter: {
        },
        formFilterCopy: {

        },
        industryId: {
          impl: new DropdownWidget(this.loadIndustryIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        areaId: {
          impl: new DropdownWidget(this.loadAreaIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        subjectType: {
          impl: new DropdownWidget(this.loadSubjectTypeDropdownList)
        },
        validity: {
          impl: new DropdownWidget(this.loadValidityDropdownList)
        },
        isOpen: {
          impl: new DropdownWidget(this.loadIsOpenDropdownList)
        },
        isDocking: {
          impl: new DropdownWidget(this.loadIsDockingDropdownList)
        },
        attachedImages: {
          impl: new UploadWidget(5)
        },
        isHelp: {
          impl: new DropdownWidget(this.loadIsHelpDropdownList)
        },
        isInit: false
      },
      userInfo: {}

    }
  },
  methods: {
    // 启动流程
    handlerStart (operation, copyItemList) {
      // 启动并保存草稿后再次提交
      if (this.draftProcessInstanceId != null && this.draftTaskId != null) {
        return this.handlerOperation(operation, copyItemList);
      }
      return new Promise((resolve, reject) => {
        this.$refs.flowRequirementForm.validate(valid => {
          if (!valid) return reject();
          this.preHandlerOperation(operation, true).then(res => {
            let formData = this.getMasterData(operation.type, (res || {}).assignee);
            return RequirementController.startAndTakeUserTaskFlowRequirementAudit(this, {
              processDefinitionKey: processDefinitionKey,
              taskVariableData: {
                ...formData.taskVariableData,
                latestApprovalStatus: operation.latestApprovalStatus
              },
              flowTaskCommentDto: {
                approvalType: operation.type
              },
              requirementDto: {
                ...formData.masterData
              },
              ...formData.relationData,
              copyData: (copyItemList || []).reduce((retObj, item) => {
                retObj[item.type] = item.id;
                return retObj;
              }, {})
            });
          }).then(res => {
            this.$message.success('启动成功！');
            resolve();
          }).catch(e => {
            reject(e);
          });
        });
      });
    },
    // 流程操作
    handlerOperation (operation, copyItemList) {
      return new Promise((resolve, reject) => {
        this.$refs.flowRequirementForm.validate(valid => {
          if (!valid) return reject();
          this.preHandlerOperation(operation, this.isDraft).then(res => {
            // 加签、减签操作
            if (operation.type === this.SysFlowTaskOperationType.CO_SIGN || operation.type === this.SysFlowTaskOperationType.SIGN_REDUCTION) {
              return this.submitConsign((res || {}).assignee, operation.type === this.SysFlowTaskOperationType.CO_SIGN);
            }
            // 驳回操作
            if (operation.type === this.SysFlowTaskOperationType.REJECT || operation.type === this.SysFlowTaskOperationType.REJECT_TO_TASK) {
              return FlowOperationController.rejectRuntimeTask(this, {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                targetTaskKey: (res || {}).targetTaskKey,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 驳回到起点
            if (operation.type === this.SysFlowTaskOperationType.REJECT_TO_START) {
              return FlowOperationController.rejectToStartUserTask(this, {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 撤销操作
            if (operation.type === this.SysFlowTaskOperationType.REVOKE) {
              this.$confirm('是否撤销此任务？').then(res => {
                return FlowOperationController.rejectHistoricTask(this, {
                  processInstanceId: this.processInstanceId,
                  taskId: this.taskId,
                  taskComment: '任务处理人撤销任务',
                  taskVariableData: {
                    latestApprovalStatus: operation.latestApprovalStatus
                  }
                });
              }).catch(e => {
                return Promise.reject(e);
              });
            }
            let formData = this.getMasterData(operation.type, (res || {}).assignee);
            let params = {
              taskId: this.taskId || this.draftTaskId,
              processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
              flowTaskCommentDto: {
                taskComment: (res || {}).message,
                approvalType: operation.type,
                delegateAssignee: operation.type === this.SysFlowTaskOperationType.TRANSFER ? (res || {}).assignee : undefined
              },
              taskVariableData: {
                ...formData.taskVariableData,
                latestApprovalStatus: operation.latestApprovalStatus
              },
              copyData: (copyItemList || []).reduce((retObj, item) => {
                retObj[item.type] = item.id;
                return retObj;
              }, {})
            }
            // 非只读状态下，提交修改数据
            if (!this.readOnly) {
              // 主表数据
              params.requirementDto = {
                ...formData.masterData
              };
              // 关联数据
              params = {
                ...params,
                ...formData.relationData
              };
            }

            return RequirementController.submitUserTaskFlowRequirementAudit(this, params);
          }).then(res => {
            this.reloadMessage(this);
            if (operation.type !== this.SysFlowTaskOperationType.CO_SIGN && operation.type !== this.SysFlowTaskOperationType.SIGN_REDUCTION) {
              this.$message.success(operation.label + '成功！');
            }
            resolve();
          }).catch(e => {
            console.log(e);
          });
        });
      });
    },
    // 保存草稿
    handlerDraft () {
      return new Promise((resolve, reject) => {
        let formData = this.getFormDataImpl();
        let params = {
          processDefinitionKey: processDefinitionKey,
          processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
          requirementDto: {
            ...formData.masterData
          },
          ...formData.relationData
        }
        RequirementController.startAndSaveDraftFlowRequirementAudit(this, params).then(res => {
          this.$message.success('草稿保存成功！');
          this.draftProcessInstanceId = res.data.processInstanceId;
          this.draftTaskId = res.data.taskId;
          resolve();
        }).catch(e => {
          reject(e);
        });
      });
    },
    // 获取表单数据
    getFormDataImpl () {
      // 一对一、一对多、多对多关联数据
      let relationData = {};

      return {
        masterData: {
          ...this.formData.Requirement
        },
        relationData: relationData
      }
    },
    // 获取流程表单数据
    getMasterData (operationType, assignee) {
      let taskVariableData;
      if (Array.isArray(this.taskVariableList) && this.taskVariableList.length > 0) {
        taskVariableData = this.taskVariableList.reduce((retObj, item) => {
          retObj[item.variableName] = this.formData.Requirement[item.variableName];
          return retObj;
        }, {});
      }
      // 会签操作设置多实例处理人集合
      assignee = (assignee && assignee !== '') ? assignee.split(',') : undefined;
      if (operationType === this.SysFlowTaskOperationType.MULTI_SIGN) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.assigneeList = assignee;
      } else if (operationType === this.SysFlowTaskOperationType.SET_ASSIGNEE) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.appointedAssignee = Array.isArray(assignee) ? assignee.join(',') : undefined;
      }

      return {
        ...this.getFormDataImpl(),
        taskVariableData
      }
    },
    // 初始化流程表单
    initFormData () {
      if (!this.isStartFlow) {
        // 流程办理
        let params = {
          processInstanceId: this.processInstanceId,
          taskId: this.taskId
        }
        let httpCall = null;
        if (this.isDraft || this.isDraft === 'true') {
          // 草稿数据
          httpCall = FlowOperationController.viewDraftData(this, {
            processDefinitionKey: processDefinitionKey,
            processInstanceId: this.processInstanceId
          });
        } else if (this.messageId != null) {
          // 抄送消息
          httpCall = FlowOperationController.viewCopyBusinessData(this, {
            messageId: this.messageId
          });
        } else {
          httpCall = (this.taskId && this.isRuntime) ? RequirementController.viewTaskBusinessDataFlowRequirementAudit(this, params) : RequirementController.viewHistoricTaskBusinessDataFlowRequirementAudit(this, params)
        }
        httpCall.then(res => {
          this.formData.Requirement = { ...res.data };
          this.flowRequirementForm.subjectType.impl.onVisibleChange(true).catch(e => {});
          this.flowRequirementForm.validity.impl.onVisibleChange(true).catch(e => {});
          this.flowRequirementForm.isOpen.impl.onVisibleChange(true).catch(e => {});
          this.flowRequirementForm.isHelp.impl.onVisibleChange(true).catch(e => {});
          this.flowRequirementForm.areaId.impl.onVisibleChange(true).catch(e => {});
          this.flowRequirementForm.industryId.impl.onVisibleChange(true).catch(e => {});
          let attachedImagesDownloadParams = {
            id: this.formData.Requirement.id,
            fieldName: 'attachedImages',
            asImage: true
          }
          this.flowRequirementForm.attachedImages.impl.fileList = this.parseUploadData(this.formData.Requirement.attachedImages, attachedImagesDownloadParams);

          if (this.formData.Requirement.industryIdDictMap && this.flowRequirementForm.industryId.impl.dirty) {
            this.flowRequirementForm.industryId.impl.dropdownList = [this.formData.Requirement.industryIdDictMap];
          }
          if (this.formData.Requirement.industryId) this.flowRequirementForm.industryId.value = [this.formData.Requirement.industryId];

          if (this.formData.Requirement.areaIdDictMap && this.flowRequirementForm.areaId.impl.dirty) {
            this.flowRequirementForm.areaId.impl.dropdownList = [this.formData.Requirement.areaIdDictMap];
          }
          if (this.formData.Requirement.areaId) this.flowRequirementForm.areaId.value = [this.formData.Requirement.areaId];

          // 获取一对多、多对多数据
          this.refreshFlowRequirementForm(true);
        }).catch(e => {});
      } else {

        // 启动流程
      }
    },
    onCancel (isSuccess) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess);
      }
    },
    /**
       * 行业下拉数据获取函数
       */
    loadIndustryIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIndustryDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },

    /**
       * 行业选中值改变
       */
    onIndustryIdValueChange (value) {
      this.formData.Requirement.industryId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
     * 对接状态下拉数据获取函数
     */
    loadIsDockingDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIsDockingDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 对接状态选中值改变
     */
    onIsDockingValueChange (value) {
    },
    loadIsHelpDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYesOrNoDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 地区id下拉数据获取函数
       */
    loadAreaIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictAreaStreet(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 地区id选中值改变
       */
    onAreaIdValueChange (value) {
      this.formData.Requirement.areaId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
       * 需求类型下拉数据获取函数
       */
    loadSubjectTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictRSTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 需求类型选中值改变
       */
    onSubjectTypeValueChange (value) {
    },
    /**
       * 有效期下拉数据获取函数
       */
    loadValidityDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictValidityDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 有效期选中值改变
       */
    onValidityValueChange (value) {
    },
    /**
       * 是否公开下拉数据获取函数
       */
    loadIsOpenDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictOpenDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 是否公开选中值改变
       */
    onIsOpenValueChange (value) {
    },
    /**
       * 更新需求表单
       */
    refreshFlowRequirementForm (reloadData = false) {
      if (!this.flowRequirementForm.isInit) {
        // 初始化下拉数据
      }
      this.flowRequirementForm.isInit = true;
    },
    /**
       * 附件照片上传成功
       */
    onAttachedImagesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.flowRequirementForm.attachedImages.impl.onFileChange(file, fileList);
        this.formData.Requirement.attachedImages = this.fileListToJson(this.flowRequirementForm.attachedImages.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
       * 移除附件照片
       */
    onAttachedImagesRemoveFile (file, fileList) {
      this.flowRequirementForm.attachedImages.impl.onFileChange(file, fileList);
      this.formData.Requirement.attachedImages = this.fileListToJson(this.flowRequirementForm.attachedImages.impl.fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    formInit () {
      this.initFormData();
    },
    closeImgViewer () {
      this.imgViewerVisible = false;
    },
    handlePreview (file) {
      this.imgViewerVisible = true
      this.imgList = []
      this.imgList.push(file.url)
    },
    ...mapActions(['reloadMessage'])
  },
  computed: {
    isStartFlow () {
      return this.processInstanceId == null;
    },
    isRuntime () {
      return typeof this.isRuntimeTask === 'string' ? this.isRuntimeTask === 'true' : this.isRuntimeTask;
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    this.userInfo = this.$store.state.userInfo
    this.formData.Requirement.createType = this.userInfo.isSpecial
    console.log(this.formData.Requirement.createType)
  }
}
</script>
